import { render } from "./ServiceItsExperienceComp.vue?vue&type=template&id=03a4def9&scoped=true"
import script from "./ServiceItsExperienceComp.vue?vue&type=script&lang=js"
export * from "./ServiceItsExperienceComp.vue?vue&type=script&lang=js"

import "./ServiceItsExperienceComp.vue?vue&type=style&index=0&id=03a4def9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03a4def9"]])

export default __exports__